import React, { useContext } from "react";
import { useNavigate  } from "react-router-dom";
import { postlogout } from "../../helper/backend-methods";
import T from "../../locale/translations-main";
import { GlobalContext } from "../../context/index"
import { fetchUserToken } from "../../helper/api-methods";
import appboy from 'appboy-web-sdk';
import AppLoader from "../../components/AppLoader";
function Logout() {
    const { updateCartCount } = useContext(GlobalContext);
    const history = useNavigate();
    setTimeout(()=>{
        postlogout().then((data)=>{
            localStorage.removeItem("authToken"); 
            localStorage.removeItem("guestToken"); 
            localStorage.removeItem("userinfo");
            localStorage.removeItem("cartItemCount");
            localStorage.removeItem("discountAttribute");
            localStorage.removeItem("enablePopup");
            localStorage.removeItem("discountProcessed");

            fetchUserToken("web/guestUserLogin").then((response) => {
                if(response.data.Status){
                    localStorage.setItem("guestToken",response.data.Data?.Token?.Access_Token);
                    localStorage.setItem("guestCustomerGuid",response.data.Data?.UserInfo?.CustomerGuid);
                    appboy.changeUser(response.data.Data.UserInfo?.CustomerGuid);   
                }
                
            })
            updateCartCount(0);
            setTimeout(()=>{
                history('/menu');
            },1000)
        })
    },1000)


    return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
            <AppLoader text={<T>Safely logging you out of your account. Please Wait...</T>} />
        </div>
    )
}

export default Logout;